/* fonts */
export const FontFamily = {
  interMedium: 'Inter-Medium',
  interBold: 'Inter-Bold',
  interBlack: 'Inter-Black',
  dIN: 'DIN',
  publicSansBold: 'PublicSans-Bold',
  anybodyBold: 'Anybody-Bold',
};
/* font sizes */
export const FontSize = {
  size_3xs: 10,
  size_xs: 12,
  size_sm: 14,
  size_4xs: 9,
  size_5xs: 8,
};
/* Colors */
export const Color = {
  color2: '#fff',
  color4: '#31373d',
  color: '#5f6975',
  color1: '#000',
  whitesmoke_100: '#e8ebef',
  whitesmoke_200: '#e8ebee',
  color3: '#9fa5ac',
  gray_100: 'rgba(0, 0, 0, 0.3)',
};
/* Paddings */
export const Padding = {
  p_5xs: 8,
  p_9xs: 4,
  p_xs: 12,
  p_11xs: 2,
};
/* border radiuses */
export const Border = {
  br_5xs: 8,
  br_9xs: 4,
  br_base: 16,
  br_11xs: 2,
};
